import { FaEnvelope, FaFacebookF, FaInstagram, FaLinkedinIn, FaPhoneAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="w-full bg-primary/20 border-t border-gray-200">
      {/* Top Section */}
      <div className="mx-auto max-w-6xl px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-gray-700">

        {/* Brand */}
        <div>
          <h2 className="text-2xl font-bold">JIGHULUKE</h2>
          <p className="mt-4 text-sm leading-relaxed text-gray-600">
            Delivering quality construction, materials, and equipment solutions
            with reliability and professionalism at the core.
          </p>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Our Services</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/services/build-construction" className="hover:text-primary transition">
                Construction & Civil Works
              </Link>
            </li>
            <li>
              <Link to="/services/fire-services" className="hover:text-primary transition">
                Fire Safety Solutions
              </Link>
            </li>
            <li>
              <Link to="/services/ict-and-security" className="hover:text-primary transition">
                ICT & Security Solutions
              </Link>
            </li>
            <li>
              <Link to="/services/fumigation-services" className="hover:text-primary transition">
                Pest & Fumigation
              </Link>
            </li>
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-primary transition">Home</Link></li>
            <li><Link to="/about" className="hover:text-primary transition">About Us</Link></li>
            <li><Link to="/projects" className="hover:text-primary transition">Projects</Link></li>
            <li><Link to="/products" className="hover:text-primary transition">Products</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <div>
            <h3 className="text-lg font-semibold mb-3">Locations</h3>
            <ul className="space-y-3 text-sm">

              <li>
                
                <div className="ml-2 space-y-1">
                  <a href="https://goo.gl/maps/XYZ1" target="_blank" rel="noopener noreferrer" className="block hover:text-primary transition">
                    Mogha, Goba, Dar es Salaam, Tanzania
                  </a>
                  <a href="https://goo.gl/maps/XYZ2" target="_blank" rel="noopener noreferrer" className="block hover:text-primary transition">
                    Mtumba, Dodoma
                  </a>
                  <a href="https://goo.gl/maps/XYZ3" target="_blank" rel="noopener noreferrer" className="block hover:text-primary transition">
                    Mbalizi Bus Stand, Mbeya
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <span className="bg-secondary text-primary p-2 rounded-full flex items-center justify-center">
                  <FaPhoneAlt />
                </span>
                +255 715 292 952
              </li>
              <li className="flex items-center gap-2">
                <span className="bg-secondary text-primary p-2 rounded-full flex items-center justify-center">
                  <FaEnvelope />
                </span>
                info@jighuluke.co.tz
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-black text-gray-300 text-sm">
        <div className="mx-auto max-w-6xl px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap gap-4">
            <div className="flex gap-3">
              <a href="https://www.facebook.com/share/1QHH1dXyJL/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-secondary bg-primary/70 p-3 rounded-full flex items-center justify-center hover:bg-primary/80 transition">
                <FaFacebookF />
              </a>
              <a href="https://www.linkedin.com/company/altair-company-limited/" target="_blank" rel="noopener noreferrer" className="text-secondary bg-primary/70 p-3 rounded-full flex items-center justify-center hover:bg-primary/80 transition">
                <FaLinkedinIn />
              </a>
              <a href="https://www.instagram.com/jighulukecoltd?igsh=MTJpMnBzNzg2OXll" target="_blank" rel="noopener noreferrer" className="text-secondary bg-primary/70 p-3 rounded-full flex items-center justify-center hover:bg-primary/80 transition">
                <FaInstagram />
              </a>
            </div>
          </div>
          <p className="text-gray-400 text-xs sm:text-sm">
            © {new Date().getFullYear()} JIGHULUKE. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
